import FormattedPropertyV2 from '../v2/components/FormattedPropertyV2';

// Re-exported from the "v2" folder so clients don't need to be aware
// of the internal file structure and we can refactor at will.

export default FormattedPropertyV2;